import * as React from 'react';

type OperatingSystem =
  | 'mac'
  | 'windows'
  | 'linux'
  | 'ios'
  | 'android'
  | null;

export default function useOperatingSystem(): OperatingSystem {
  const [operatingSystem, setOS] =
    React.useState<OperatingSystem>(null);

  React.useEffect(() => {
    setOS(detectOperatingSystem());
  }, []);

  return operatingSystem;
}

function detectOperatingSystem() {
  // Allow me to test different operating systems with a query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const osOverride = urlParams.get('pretend-os') as OperatingSystem;

  if (osOverride) {
    return osOverride;
  }

  let platformString =
    // @ts-ignore
    window.navigator?.userAgentData?.platform || navigator.platform;

  if (!platformString) {
    return null;
  }

  // force lowercase, since there's an inconsistency in the  userAgentData.platform
  platformString = platformString.toLowerCase();

  // `navigator.platform` can contain things like "macIntel" or "Win32". We want to standardize all the sub-versions.
  if (platformString.match(/mac/i)) {
    return 'mac';
  } else if (platformString.match(/win/i)) {
    return 'windows';
  } else if (platformString.match(/linux/i)) {
    return 'linux';
  } else if (platformString.match(/iP/i)) {
    return 'ios';
  } else if (platformString.match(/android/i)) {
    return 'android';
  }

  return null;
}
